import { handleActions } from 'redux-actions';
import { ERROR_CODE } from '@airwallex/airwallex-payment-elements';

export const ERROR_ACTIONS = {
  SET: 'CHECKOUT/ERROR/SET',
  CLEAN: 'CHECKOUT/ERROR/CLEAN',
};

export interface Error {
  code?: ERROR_CODE;
  message?: string;
  provider_original_response_code?: string;
}

export const initialError: Error = {};

export const reducer = handleActions(
  {
    [ERROR_ACTIONS.SET]: (_, action) => action.payload,
    [ERROR_ACTIONS.CLEAN]: () => initialError,
  },
  initialError,
);

export default reducer;
